import qs from 'qs'
import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { IGetRequestObject, ITrainingComplianceByType } from '../../interfaces'

type QueryObject = {
  asOfDate?: string
}

const getTrainingComplianceByTypeRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })
  return {
    method: 'get',
    url: `${config.baseUrl}/training/compliance/by-type${queryString}`,
  }
}

const useTrainingComplianceByTypeQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingComplianceByType | undefined
>({
  getRequest: getTrainingComplianceByTypeRequest,
  getQueryKey: (params, queryObject) => [
    'training-compliance-by-type',
    queryObject?.asOfDate
  ],
})

const useTrainingComplianceByTypeQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingComplianceByType | undefined, Error>,
) => {
  const trainingComplianceByTypeQuery = useTrainingComplianceByTypeQueryBase(
    undefined,
    queryObject,
    options,
  )
  return { ...trainingComplianceByTypeQuery }
}

export default useTrainingComplianceByTypeQuery